"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useLocale } from "@/content/i18n/context";
import { t } from "@/content/i18n/messages";
import { WHATSAPP_NUMBER, ezychatDemoMessage, ezychatDemoSource, floatingWhatsappMessage, whatsappHref } from "@/lib/whatsapp";

export function ContactSpeedDial() {
  const pathname = usePathname() || "/";
  const locale = useLocale();
  const [pageTitle, setPageTitle] = useState<string | undefined>(undefined);
  const demoSource = ezychatDemoSource(pathname);
  const label = t(locale, demoSource ? "Try our EzyChat AI assistant on WhatsApp" : "Chat with us on WhatsApp");

  useEffect(() => {
    setPageTitle(undefined);
    const timer = setTimeout(() => setPageTitle(document.title || undefined), 300);
    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <div
      data-floating-fab
      className="ezychat-contact-enter fixed right-4 z-50 flex w-14 flex-col items-center gap-1.5 sm:right-6"
      style={{ bottom: "max(1.5rem, calc(env(safe-area-inset-bottom) + 0.75rem))" }}
    >
      <a
        id="whatsapp-floating-btn"
        href={whatsappHref(demoSource ? ezychatDemoMessage(demoSource) : floatingWhatsappMessage(pathname, pageTitle))}
        target="_blank"
        rel="noopener noreferrer"
        data-track-event="contact_whatsapp_click"
        data-track-location="floating_button"
        data-track-type="fab_primary"
        data-track-action={demoSource ? "ezychat_ai_demo" : "enquiry"}
        data-track-phone={WHATSAPP_NUMBER}
        aria-label={label}
        aria-describedby="ezychat-contact-credit"
        title={`${label} · ${t(locale, "Powered by EzyChat")}`}
        className="ezychat-contact-button relative flex h-14 w-14 items-center justify-center rounded-full border border-primary/20 bg-card shadow-lg hover:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      >
        <Image
          src="/images/ezychat/ezychat-logo.webp"
          alt="EzyChat"
          width={41}
          height={40}
          className="ezychat-contact-logo h-10 w-auto rounded-xl"
        />
      </a>
      <a
        id="ezychat-contact-credit"
        href="https://ezychat.ai/"
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-md bg-card px-1.5 py-1 text-center text-[10px] leading-tight text-neutral-muted shadow-sm hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        {t(locale, "Powered by EzyChat")}
      </a>
    </div>
  );
}
